import axiosInstance from './base.api';
import { getCookie, getEnvironmentVariable } from '../utils';

export interface JWTResponseDTO {
    token: string;
    user: {
        id: string;
        username: string;
        role: string;
        name: string;
        email: string;
        date_created: number;
        last_login: number | null;
        expertise: string | null;
        image: string | null;
        description: number | null;
        created_at: number | null;
        updated_at: number | null;
    };
}

export const getReactToken = async (): Promise<{
    token: string;
    userInfo: JWTResponseDTO['user'];
}> => {
    const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
    const response = await axiosInstance.post<JWTResponseDTO>(`${platformURL}/JWT/react/login`);

    return {
        token: response.data.token,
        userInfo: response.data.user,
    };
};

export const getSessionToken = async (): Promise<{
    token: string;
    userInfo: JWTResponseDTO['user'];
}> => {
    const session = getCookie('session_for_front');
    const encodedToken = encodeURIComponent(encodeURI(session));
    const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
    const response = await axiosInstance.post(`${platformURL}/JWT/session/login?session=${encodedToken}`);

    return {
        token: response.data.token,
        userInfo: response.data.user,
    };
};
